export default __webpack_public_path__ + "ccf85b106abda1836a0aac653dadcc75.jpg";